<div class="db-activity-notification db-activity-notification_status_{{activityNotification.status}} {{activityNotification.id}}">
  <div class="db-activity-notification__icon" [ngSwitch]="activityNotification.status">
    <i class="db-icon db-icon-info" *ngSwitchCase="ActivityNotificationStatus.RUNNING"></i>
    <i class="db-icon db-icon-success" *ngSwitchCase="ActivityNotificationStatus.DONE"></i>
    <i class="db-icon db-icon-error" *ngSwitchCase="ActivityNotificationStatus.FAILED"></i>
    <i class="db-icon db-icon-warning" *ngSwitchCase="ActivityNotificationStatus.CANCELED"></i>
  </div>

  <div class="db-activity-notification__info">
    <div class="db-activity-notification__message" [innerHTML]="message"></div>
    <div class="db-activity-notification__date">{{siteUrl}}</div>
    <div class="db-activity-notification__date">{{activityNotification.date | timeFromNow}}</div>
  </div>
</div>
